/*global ajax_object */

// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/elementor/example-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/gutenberg/acf-example-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();
function toggleSearchButtons() {
  $('.search').each(function () {
    const $form = $(this);
    const $input = $form.find('.search__input');
    const hasValue = $input.val().trim().length > 0;
    const isFocused = $input.is(':focus');

    if (isFocused || hasValue) {
      $form.addClass('search--show-close');
      $form.removeClass('search--show-submit');
    } else {
      $form.removeClass('search--show-close');
      $form.addClass('search--show-submit');
    }
  });
}

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Blog loadmore
   */
  let postPerPage = 12;

  function loadScrollPosts(
    response,
    taxonomy = false,
    category = null,
    name = null,
    author = null
  ) {
    let offset = taxonomy ? 0 : $('.post__wrapper').length;
    console.log(offset);
    let postType = $('.post-load').data('post-type');
    category =
      category || $('.post-list__category').find('.active').data('category');
    name = name || $('.post-list__category').find('.active').data('name');
    author = author || $('.post-list__category').find('.active').data('author');

    $.ajax({
      type: 'GET',
      dataType: 'json',
      url: ajax_object.ajax_url,
      data: {
        postType: postType,
        action: 'loadmore',
        offset: offset,
        postperpage: postPerPage,
        category: category,
        author: author,
      },
      beforeSend: function () {
        $('.ajax-loading').hide();
      },
      success: function (response) {
        $('.ajax-loading').hide();
        if (taxonomy) {
          $('.ajax-posts').html(response.html);
          $('.reset').text(name);
          $('.post-list__category_wrapper').removeClass('show-post');
        } else {
          $('.ajax-posts').append(response.html);
        }
        if ($('.post__wrapper').length < response.post_count) {
          $('.ajax-loading').show();
        }
      },
      error: function (result) {
        console.warn(result);
      },
    });
    return false;
  }

  $('.cat-name').click(function (e) {
    e.preventDefault();
    $('.cat-name').removeClass('active');
    $(this).addClass('active');

    const category = $(this).data('category');
    const name = $(this).data('name');
    const author = $(this).data('author');
    loadScrollPosts('response', true, category, name, author);
  });

  $('.post-load').click(function () {
    loadScrollPosts();
  });

  $(document).on('click', '.reset', function () {
    $(this).toggleClass('active');
    $('.post-list__category_wrapper').toggleClass('show-post');
  });

  /**
   * Sponsors Slider
   */
  $('.home-sponsors__slider').slick({
    slidesToShow: 1,
    arrows: true,
    dots: false,
    rows: false,
    autoplay: true,
  });

  /**
   * Hide search icon
   */
  // $('.search__input').on('focus', function () {
  //   $(this).closest('.search').addClass('search--focused');
  // });
  //
  // $('.search__input').on('blur', function () {
  //   $(this).closest('.search').removeClass('search--focused');
  // });
  toggleSearchButtons();

  $(document).on('input focus blur', '.search__input', function () {
    toggleSearchButtons();
  });

  $(document).on('click', '.search__close-icon', function () {
    $('.search').each(function () {
      const $input = $(this).find('.search__input');
      $input.val('').blur();
    });
    toggleSearchButtons();
  });
  /**
   * Hide Members Only content
   */
  function handleUserAuthentication() {
    // Get "auth" parameter from URL (e.g. ?auth=1)
    const urlParams = new URLSearchParams(window.location.search);
    const auth = urlParams.get('auth');

    // Save auth status if redirected with auth=1
    if (auth === '1') {
      localStorage.setItem('user', JSON.stringify({ isAuthenticated: true }));
      // Optional: clean up URL
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }

    let user = null;
    if (localStorage.getItem('user')) {
      try {
        user = JSON.parse(localStorage.getItem('user'));
      } catch (e) {
        console.error('Invalid user data in localStorage');
      }
    }

    // Show/hide protected content
    if ($('.members_only').length) {
      if (!user || !user.isAuthenticated) {
        $('.video-post__content').hide();
        $('.not-logged-message').show();
      } else {
        $('.video-post__content').show();
        $('.not-logged-message').hide();
      }
    }

    // Handle global Sign In / Log Out button
    if (user && user.isAuthenticated) {
      $('.sign-in-btn')
        .text('Log Out')
        .addClass('logout-btn')
        .removeClass('sign-in-btn');
    }

    // Log out action
    $(document).on('click', '.logout-btn', function (e) {
      e.preventDefault();
      localStorage.removeItem('user');
      location.reload();
    });
  }

  handleUserAuthentication();

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  const tabButtons = document.querySelectorAll('.tab-button');
  const tabContents = document.querySelectorAll('.tab-content');

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const target = button.getAttribute('data-tab');

      tabButtons.forEach((btn) => btn.classList.remove('active'));
      tabContents.forEach((content) => content.classList.remove('active'));

      button.classList.add('active');
      document.getElementById(target).classList.add('active');
    });
  });

  // Tabs with toggle
  $('.trial-talk__faq-item').on('click', function () {
    const $this = $(this);
    const $answer = $this.find('.trial-talk__faq-item-answer');

    if ($this.hasClass('active')) {
      $this.removeClass('active');
      $answer.slideUp();
    } else {
      $('.trial-talk__faq-item.active')
        .removeClass('active')
        .find('.trial-talk__faq-item-answer')
        .slideUp();

      $this.addClass('active');
      $answer.slideDown();
    }
  });

  // $('.js-sidebar-slider').on('init', function (event, slick) {
  //   $('.slider-total').text(slick.slideCount);
  //   $('.slider-current').text(slick.currentSlide + 1);
  // });
  //
  // $('.js-sidebar-slider').on(
  //   'afterChange',
  //   function (event, slick, currentSlide) {
  //     $('.slider-current').text(currentSlide + 1);
  //   }
  // );

  $('.js-sidebar-slider').slick({
    slidesToShow: 1,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    autoplay: true,
    // prevArrow: $('.slider-nav__next'),
    // nextArrow: $('.slider-nav__prev'),
  });

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});
/**
 * Scripts which runs on scrolling
 */
let header = document.querySelector('header');
let lastScrollY = window.scrollY;

if (window.scrollY === 0) {
  header.classList.add('header-scroll-top');
  header.classList.remove('header-scroll');
} else {
  header.classList.remove('header-scroll-top');
  header.classList.add('header-scroll');
}

$(window).on('scroll', function () {
  if (window.scrollY > lastScrollY) {
    header.classList.remove('header-scroll-top');
    header.classList.add('header-scroll');
  } else if (window.scrollY === 0) {
    header.classList.add('header-scroll-top');
    header.classList.remove('header-scroll');
  }
  lastScrollY = window.scrollY;
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});
